import { useEffect, useRef, useState } from 'react';

export function useElementSize(initial?: { height?: number; width?: number }) {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(initial?.height || 0);
  const [width, setWidth] = useState(initial?.width || 0);

  useEffect(() => {
    const element = ref.current;

    if (!element) return;

    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        setHeight(entry.contentRect.height);
        setWidth(entry.contentRect.width);
      }
    });

    resizeObserver.observe(element);

    // eslint-disable-next-line consistent-return
    return () => {
      resizeObserver.unobserve(element);
    };
  }, []);

  return [ref, { height, width }] as const;
}
